//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable vue/no-mutating-props */
import { mapState } from "vuex";
import QfModalModels from "@/components/UserInterfaces/qf-modal-models.vue";
import AQModalDlg from "@/components/Generics/AQModalDlg/AQModalDlg.vue";

const camelize = str => str.replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, (match, index) => {
    if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces
    return index === 0 ? match.toLowerCase() : match.toUpperCase();
});

const types = [
    { label: "Date", value: "agDateColumnFilter" },
    { label: "Text", value: "agTextColumnFilter" },
    { label: "None", value: false },
    { label: "Numeric", value: "agNumberColumnFilter" }
];

export default {
    name: "QfMColumnProperties",
    components: { AQModalDlg, QfModalModels },
    props: {
        config: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            types,
            autoField: false,
            localShow: true,
            actions: [{ label: "Save", name: "set", disable: false }],
            getActions: [
                { icon: "mdi-file-tree", handler: () => { this.openModel(); } },
                { icon: "mdi-close-circle", content: true, handler: () => { this.clearValue(); } }
            ],
            constraints: null,
            localGet: null,
            showModal: false,
            typeOptions: [
                { label: "None", value: "" },
                { label: "Number", value: "decimal" },
                { label: "Date", value: "date" },
                { label: "Time", value: "time" },
                { label: "Date-time", value: "datetime" }
            ],
            formatsOptions: {
                decimal: Object.freeze([
                    { label: "System settings", value: "local" },
                    { label: "Custom", value: "custom" }
                ]),
                date: Object.freeze([
                    { label: "DD-MM-YYYY", value: "DD-MM-YYYY" },
                    { label: "MM-DD-YYYY", value: "MM-DD-YYYY" },
                    { label: "YYYY-MM-DD", value: "YYYY-MM-DD" },
                    { label: "YYYY-DD-MM", value: "YYYY-DD-MM" }
                ]),
                time: Object.freeze([
                    { label: "HH:mm", value: "HH:mm" }
                ]),
                datetime: Object.freeze([
                    { label: "DD-MM-YYYY HH:mm", value: "DD-MM-YYYY HH:mm" },
                    { label: "MM-DD-YYYY HH:mm", value: "MM-DD-YYYY HH:mm" },
                    { label: "YYYY-MM-DD HH:mm", value: "YYYY-MM-DD HH:mm" },
                    { label: "YYYY-DD-MM HH:mm", value: "YYYY-DD-MM HH:mm" }
                ])
            }
        };
    },
    computed: {
        ...mapState("components", ["properties", "activeComponent", "parsed"]),
        localProperties() {
            return this.properties[this.activeComponent];
        },
        path() {
            return this.localProperties.get;
        },
        isDisabled() {
            return false;
        },
        mapType() {
            const { get } = this.config;
            const { type } = this.getMapType(get);

            return (type && type.toLowerCase()) || null;
        },
        isAttachmentOrNull() {
            return this.mapType === "attachment" || this.mapType === null;
        },
        isFormatDisabled() {
            return !(this.mapType === null || ["integer", "decimal", "string", "date", "time", "datetime"].includes(this.mapType));
        },
        isCustom() {
            const { format } = this.config._meta;
            return format && format.type === "custom";
        }
    },
    watch: {
        mapType() {
            if (this.isFormatDisabled) {
                const { format } = this.config._meta;
                Object.assign(format, { dataType: "", type: "", decimal: ".", thousands: "," });
            }
        },
        columns: {
            handler(val) {
                this.localColumns = val || [];
            },
            immediate: true
        },
        isAttachmentOrNull: {
            handler(val) {
                if (!val) {
                    this.config.previewAttach = false;
                }
            },
            immediate: true
        }
    },
    mounted() {
        this.localGet = this.config.get;
        this.updateAutoField();
    },
    methods: {
        setDefaultFormat(dataType) {
            if (dataType) {
                this.config._meta.format.type = this.formatsOptions[dataType][0].value;
            } else {
                this.config._meta.format.type = "";
            }
        },
        getMapType(mapValue) {
            const data = { type: null, key: null };

            if (mapValue && mapValue.startsWith("m_")) {
                const pathList = mapValue.substring(2).split(".");

                if (pathList.length > 1) {
                    let cursor = this.parsed.modelClasses[pathList.splice(0, 1)[0]];

                    pathList.forEach(node => { cursor = cursor && cursor.fields ? cursor.fields[node] : null; });
                    if (cursor) {
                        data.type = cursor.type;
                        data.key = cursor.key;
                    }
                }
            }

            return data;
        },
        openModel() {
            this.showModal = true;
        },
        getUpdate(newData) {
            this.localGet = newData;
            this.config.get = newData;
        },
        clearValue() {
            this.localGet = null;
            this.config.get = null;
        },
        modalAction(action) {
            if (action.simple === "hide") {
                this.localShow = action.detailed === "action_backdrop";
            } else if (action.simple === "action") {
                if (action.detailed === "set") {
                    this.$emit("update", this.config);
                    this.localShow = false;
                }
            }
        },
        modalAfterHide() {
            this.$emit("input", false);
        },
        onNameChange() {
            const { headerName } = this.config;

            if (this.autoField) {
                this.config.field = camelize(headerName);
            }
        },
        onFieldChange() {
            this.updateAutoField();
        },
        updateAutoField() {
            this.autoField = !this.config.field;
        }
    }
};
